// ADA: isolate the page behind the accessory dialog and contain keyboard focus.
$(function () {
  let case_popup_left_container_container;
  let lastShowcaseTrigger = null;
  let showcaseIsolatedElements = [];
  let showcaseFocusGuard = null;
  let showcaseKeydownHandler = null;
  let showcaseScreenReaderLoopHandler = null;
  let showcaseInitialFocusTimer = null;

  function showcaseFocusables(dialog) {
    const container = dialog?.querySelector('.case-popup-content-container-parent');
    if (!container) return [];
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((element) => {
        if (element.classList.contains('last-focusable-element')) return false;
        if (element.closest('[aria-hidden="true"], [inert]')) return false;
        let current = element;
        while (current && current !== container) {
          const style = window.getComputedStyle(current);
          if (style.display === 'none' || style.visibility === 'hidden') return false;
          current = current.parentElement;
        }
        return element.getClientRects().length > 0;
      });
  }

  function toggleShowcaseBackdropAccessibility(dialog, hidden) {
    if (!dialog) return;
    if (!hidden) {
      showcaseIsolatedElements.forEach((state) => {
        if (state.ariaHidden === null) state.element.removeAttribute('aria-hidden');
        else state.element.setAttribute('aria-hidden', state.ariaHidden);
        if (!state.inert) state.element.removeAttribute('inert');
      });
      showcaseIsolatedElements = [];
      return;
    }
    showcaseIsolatedElements = [];
    let current = dialog;
    while (current && current !== document.body) {
      const parent = current.parentElement;
      if (!parent) break;
      Array.from(parent.children).forEach((sibling) => {
        if (sibling === current || sibling.contains(dialog)) return;
        showcaseIsolatedElements.push({
          element: sibling,
          ariaHidden: sibling.getAttribute('aria-hidden'),
          inert: sibling.hasAttribute('inert'),
        });
        sibling.setAttribute('aria-hidden', 'true');
        sibling.setAttribute('inert', '');
      });
      current = parent;
    }
  }

  function handleShowcaseDialogKeydown(event, dialog) {
    if (!dialog || dialog.getAttribute('aria-hidden') === 'true') return;
    if (event.key === 'Escape') {
      event.preventDefault();
      fadeOutPopUp();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusables = showcaseFocusables(dialog);
    if (!focusables.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const index = focusables.indexOf(document.activeElement);
    const next = event.shiftKey
      ? (index <= 0 ? focusables.length - 1 : index - 1)
      : (index < 0 || index === focusables.length - 1 ? 0 : index + 1);
    focusables[next].focus();
  }
  function changeProductQty(that,flag=false){
      let val = !flag ? +that.data("qty") : 0,
       cur_val = +that.parents(".case-item-container").find(".js-case-qty__num").prop("value") + val;
        let max=+that.parents(".case-item-container").find(".js-case-qty__num").prop("max")
    if(cur_val>=0 && cur_val<=max)  {
      that.parents(".case-item-container").find(".js-case-qty__num").prop("value", cur_val);
      that.parents(".case-container-item").find(".tips-content").length>0 && that.parents(".case-container-item").find(".tips-content").hide()
    }else if(cur_val>max){
      that.parents(".case-item-container").find(".js-case-qty__num").prop("value", max);
      that.parents(".case-container-item").find(".tips-content").length>0 && that.parents(".case-container-item").find(".tips-content").show()
    }
  }
  function calcProductPrice(total_price){
   return  window.theme.Currency.formatMoney(total_price, window.theme.strings.moneyFormat)
  }
  function update_out_inside_qty(direction = "outside") {
    let str = direction == "inside" ? ".case-popup-content" : ".header-case-content";
    let str_1 = direction == "inside" ? ".header-case-content" : ".case-popup-content";
     $(`${str} .case-item-container`).each(function () {
      let id = +$(this).find(".js-case-qty__num").data("id"),
        val = $(this).find(".js-case-qty__num").prop("value"),
        index=$(this).data("index")
      $(`${str_1} .case-item`).find(`input[data-id=${id}]`).prop("value", val);
      updateProductPrice( $(`${str_1} .case-container-item[data-index="${index}"]`));
    });
  }



  function updateProductPrice(that) {
    let this_val=that.find(".js-case-qty__num")
        val= +this_val.prop("value")>0 ? this_val.prop("value") : 1
       total_price=val * this_val.data("price") 
    flag=that.hasClass("tips-container")
     let compare_at_price = val * this_val.data("compare_at_price")
      that.find(".item-price .on_sale-price").html( calcProductPrice(total_price) );
      compare_at_price>0 && that.find(".item-price .compare_at-price").html( calcProductPrice(compare_at_price) );
     if(flag){
      that.find(".item-price").html(calcProductPrice(total_price) )
      const confirmButton = that.find('.confirm-btn');
      const confirmLabel = confirmButton.data('confirm-label') || confirmButton.attr('aria-label') || 'Confirm';
      confirmButton.attr('aria-label', `${confirmLabel.split(',')[0]}, ${confirmButton.find('.item-price').text().trim()}`);
    }
  }
  function update_totalProductPrice(){
    let total_price=+$("[data-product-template-container] .custom_add_to_cart").data("on_sale_price")
    let total_compare_price=!$("[data-product-template-container] .custom_add_to_cart").data("compare_at_price")? total_price : +$("[data-product-template-container] .custom_add_to_cart").data("compare_at_price")
    $(".header-case-content .case-item .js-case-qty__num").each(function(){
      let temp=+$(this).data("price")*$(this).prop("value")
      total_price+=temp
      total_compare_price+=!$(this).data("compare_at_price") ? temp : $(this).data("compare_at_price")*$(this).prop("value")
    })
    let val=calcProductPrice(total_price),val_compare=calcProductPrice(total_compare_price)
    let off_price = calcProductPrice(total_compare_price-total_price) + ' OFF';
    $("[data-product-template-container] .show-discount").text(off_price)
    $("[data-product-template-container] .product_on-sale-price").text(val)

      if(total_compare_price==total_price){
        $("[data-product-template-container] .product_compare-at-price").remove()
      }else{
        if($("[data-product-template-container] .price-container").find(".product_compare-at-price").length>0){
          $("[data-product-template-container] .product_compare-at-price").text(val_compare)
          }else{
            $("[data-product-template-container] .product_on-sale-price").after(`<span class='product-single__price--compare-at product_compare-at-price'>${val_compare}</span>`);
          }
      }
  }

  async function addOneToCart(variants) {
   for(let i=0;i<variants.length;i++){
    let variant=variants[i]
      let response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variant.id, quantity: variant.quantity }),
      });
      if (!response.ok) {
          throw new Error('添加产品失败: ' + variant.id);
       }
       const data = await response.json();
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    // 全部加购完成后，自动处理阶梯赠品
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (window.updateStepCartGift) {
        await window.updateStepCartGift(cart);
      }
    } catch (e) { console.error('自动赠品处理失败', e); }
    $("[data-product-template-container] .custom_add_to_cart").removeClass("loading");
    $(".js-drawer-open-button-right").trigger("click");
  }

  function fadeInPopUp() {
    $("html").addClass("overflow-hidden");
    let dialog = $(".product-showcase-info-container .case-popup-content").first();
    if (!dialog.length) return;
    lastShowcaseTrigger = document.activeElement;
    dialog.removeClass("caseopacity0");
    dialog.removeAttr('aria-hidden inert');
    dialog[0].querySelector('.first-focusable-element')?.focus({ preventScroll: true });
    toggleShowcaseBackdropAccessibility(dialog[0], true);

    const screenReaderLoop = dialog.find('.last-focusable-element');
    screenReaderLoop
      .attr('tabindex', '0')
      .attr('aria-hidden', 'false')
      .attr('role', 'button')
      .attr('aria-label', dialog.find('.first-focusable-element').attr('aria-label'));

    if (showcaseKeydownHandler) {
      document.removeEventListener('keydown', showcaseKeydownHandler, true);
    }
    showcaseKeydownHandler = (event) => handleShowcaseDialogKeydown(event, dialog[0]);
    document.addEventListener('keydown', showcaseKeydownHandler, true);

    if (showcaseFocusGuard) {
      document.removeEventListener('focusin', showcaseFocusGuard, true);
    }
    showcaseFocusGuard = function (event) {
      if (!dialog[0].contains(event.target)) {
        const closeButton = dialog[0].querySelector('.first-focusable-element');
        (closeButton || showcaseFocusables(dialog[0])[0])?.focus({ preventScroll: true });
      }
    };
    document.addEventListener('focusin', showcaseFocusGuard, true);

    if (showcaseScreenReaderLoopHandler) {
      dialog[0].removeEventListener('focusin', showcaseScreenReaderLoopHandler);
    }
    showcaseScreenReaderLoopHandler = function (event) {
      if (!event.target.classList.contains('last-focusable-element')) return;
      dialog[0].querySelector('.first-focusable-element')?.focus({ preventScroll: true });
    };
    dialog[0].addEventListener('focusin', showcaseScreenReaderLoopHandler);

    dialog.find(".tips-content").hide();
    update_out_inside_qty();

    if (showcaseInitialFocusTimer) clearTimeout(showcaseInitialFocusTimer);
    requestAnimationFrame(function () {
      showcaseInitialFocusTimer = setTimeout(function () {
        if (dialog.attr('aria-hidden') === 'true') return;
        dialog[0].querySelector('.first-focusable-element')?.focus({ preventScroll: true });
        showcaseInitialFocusTimer = null;
      }, 50);
    });
  }
  function fadeOutPopUp(flag = false) {
    $("html").removeClass("overflow-hidden");
    $(".product-showcase-info-container .case-popup-content").addClass("caseopacity0");
    const dialog = document.querySelector('.product-showcase-info-container .case-popup-content');
    if (dialog) {
      dialog.setAttribute('aria-hidden', 'true');
      dialog.setAttribute('inert', '');
      const screenReaderLoop = dialog.querySelector('.last-focusable-element');
      if (screenReaderLoop) {
        screenReaderLoop.setAttribute('tabindex', '-1');
        screenReaderLoop.setAttribute('aria-hidden', 'true');
        screenReaderLoop.removeAttribute('role');
        screenReaderLoop.removeAttribute('aria-label');
      }
      if (showcaseScreenReaderLoopHandler) {
        dialog.removeEventListener('focusin', showcaseScreenReaderLoopHandler);
      }
    }
    toggleShowcaseBackdropAccessibility(dialog, false);
    if (showcaseKeydownHandler) document.removeEventListener('keydown', showcaseKeydownHandler, true);
    showcaseKeydownHandler = null;
    if (showcaseFocusGuard) document.removeEventListener('focusin', showcaseFocusGuard, true);
    showcaseFocusGuard = null;
    showcaseScreenReaderLoopHandler = null;
    if (showcaseInitialFocusTimer) clearTimeout(showcaseInitialFocusTimer);
    showcaseInitialFocusTimer = null;
    if (flag) {
      update_out_inside_qty("inside");
    }
    if (lastShowcaseTrigger && document.contains(lastShowcaseTrigger)) lastShowcaseTrigger.focus();
    lastShowcaseTrigger = null;
  }
  function syncShowcasePanelAccessibility(index) {
    document.querySelectorAll('.case-popup-left-container > .swiper > .swiper-wrapper > .swiper-slide').forEach((slide, slideIndex) => {
      const active = slideIndex === Number(index);
      slide.setAttribute('aria-hidden', String(!active));
      slide.toggleAttribute('inert', !active);
    });
  }

  function setOriginPopUpContent(index) {
    const selected = $(".case-popup-right").find(`.right-item[data-index="${index}"]`);
    selected.addClass("active").attr('aria-selected', 'true').siblings().removeClass("active").attr('aria-selected', 'false');
    case_popup_left_container_container.slideTo(index);
    syncShowcasePanelAccessibility(index);
  }

 $(".case-popup-content").click(function(){
  fadeOutPopUp();
 })
$(".case-popup-content-container").click(function(event){
  event.stopPropagation()
})
  $(".product-showcase-info-container .header-case-btn").on(
    "click",
    function () {
      // 点击弹出窗口
      fadeInPopUp();
    }
  );
  $(".product-showcase-info-container .case-hide-btn").on("click", function () {
    // 点击隐藏窗口
    fadeOutPopUp();
  });
  // 点击对应的item进入弹窗
  $(".product-showcase-info-container .header-case-content .case-item").on(
    "click keydown",
    function (e) {
       if (e.type === 'keydown' && e.target.closest('button, input, a')) return;
       if (e.type === 'keydown' && e.key !== "Enter" && e.key !== " ") {
         return; 
       }
      if (e.type === 'keydown') e.preventDefault();
      let index = $(this).parents(".swiper-slide").data("index");
      setOriginPopUpContent(index);
      fadeInPopUp();
      let val=+$(this).find(".js-case-qty__num").prop("value")
      if(val>0){
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).addClass("active")
      }else{
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).removeClass("active")
      }
      
    }
  );
  // 点击产品加购根据每个产品的id来循环加购
  $("[data-product-template-container] .custom_add_to_cart").click(
    function () {
      let product_qty= +$(this).parents("[data-product-form]").find(".product-single__quantity .js-qty__num").prop("value")
      product_qty= product_qty > 1 ? product_qty :1
      $(this).addClass("loading")
      // 循环每个不同的产品
      let arr_item = [
        {
          id:$(this).data("id"),
          quantity:product_qty
        }
      ];
      $(".header-case-content .js-case-qty__num").each(function () {
        let qty = +$(this).prop("value");
        if (qty > 0) {
          let obj = {
            id: $(this).data("id"),
            product_id:$(this).data("product-id"),
            quantity: qty,
          };
          arr_item.push(obj);
        }
      });
      
      arr_item.length > 0 && addOneToCart(arr_item);
    }
  );
  // 点击该处按钮实现+1   点击该处按钮实现-1
  $(".product-showcase-info-container .js-case__adjust").on(
    "click",
    function (event) {
      let that = $(this),that_parent=$(this).parents(".case-item-container");
      changeProductQty(that)
      updateProductPrice(that_parent);
      if(!!$(this).data("layout")){
        update_totalProductPrice()
      }
      return false;
    }
  );
  $(".product-showcase-info-container .case-popup-content .js-case-qty__num").on("change",function(){
        let that=$(this),that_parent=$(this).parents(".case-item-container");
        updateProductPrice(that_parent);
        changeProductQty(that,true)
  })
  // 弹窗切换item状态
  var case_right_item = $(".case-popup-right .right-item");
  case_right_item.on("click", function () {
    let index = $(this).data("index");
    setOriginPopUpContent(index);
  });
 case_right_item.on('keydown', function(e) {
   if(e.key == 'Enter' || e.key == ' '){
     e.preventDefault(); 
     e.stopPropagation();
      $(this).trigger('click');
   }
});
  // m端点击弹窗关闭
  $(".case-popup-content .m-close ").on("click", function () {
      fadeOutPopUp();
  });
  //点击确定加购
  $(".case-popup-left .confirm-btn ").on("click keydown", function (event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.type === 'keydown') event.preventDefault();
    let index=$(this).parents(".left-item").data("index")
    let val=+$(this).parents(".case-item-container").find(".js-case-qty__num").prop("value")
      update_out_inside_qty("inside");
      calcProductPrice()
      update_totalProductPrice()
      if(val>0){
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).addClass("active")
       }else{
        $(`.case-popup-right .right-item[data-index="${index}"]  .add_to_cart_btn`).removeClass("active")
       }
  });

  //循环里面的swiper
  case_popup_left_container_container = new Swiper(
    ".case-popup-left-container>.swiper",
    {
      allowTouchMove: false,
      autoHeight:true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      on: {
        init: function () { syncShowcasePanelAccessibility(this.activeIndex); },
        slideChange: function () { syncShowcasePanelAccessibility(this.activeIndex); },
      },
      
    }

  );

  $(".case-popup-left .left-item").each(function (index) {
    new Swiper(`.left-swiper-${index} .swiper`, {
      pagination: {
        el: `.left-swiper-${index} .swiper-pagination`,
        clickable: true,
      },
    });
  });
  function swiperFn(){
    if ($(window).width() <= 589) {

    new Swiper(".header-case-content .swiper", {
      autoHeight:true,
      navigation: {
        nextEl: ".header-case-content .swiper-button-next",
        prevEl: ".header-case-content .swiper-button-prev",
      },
      a11y : {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
      },
    });
  }
  }
  swiperFn()
  $(window).resize(function(){
    swiperFn()
  })
});
